import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, Subtitle1, Caption1, Body1Stronger, Switch, DialogActions, Button } from "@fluentui/react-components";
import { UserLoginActionCreators } from "../store/Login";
import { FEVersion, FEBuildDate } from "../Version";
import { useTranslation } from "react-i18next";
import { useEditorStyles } from "./Styles/Editor";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { useRigths } from "./Tools/ObjectLoader";

interface AboutProps {
    closeDialog: () => void;
}

export const About = ({ closeDialog }: AboutProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const styles2 = useEditorStyles();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const viewAdminInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewAdminInfo);
    const { isAdmin, seeDebugInfo, version, buildTime } = useRigths();

    return <Dialog
        open={true}
        modalType="modal">
        <DialogSurface>
            <DialogBody>
                <DialogTitle>{t("About")}</DialogTitle>
                <DialogContent>
                    <div className={styles2.ContentBoxBrandBackground}>
                        <Subtitle1>Front end</Subtitle1>
                        <div className={styles2.ContentBoxBrandBackgroundGrid} >
                            <Caption1>Version</Caption1><Body1Stronger>{FEVersion}</Body1Stronger>
                            <Caption1>Build Date</Caption1><Body1Stronger>{new Date(FEBuildDate).toLocaleString()}</Body1Stronger>
                        </div>
                    </div>
                    <div className={styles2.ContentBoxBrandBackground} style={{ marginTop: "8px" }}>
                        <Subtitle1>Back end</Subtitle1>
                        {viewDebugInfo &&
                            <pre style={{ overflow: 'none' }} >{JSON.stringify(process.env, null, 2)}</pre>
                        }
                        <div className={styles2.ContentBoxBrandBackgroundGrid} >
                            <Caption1>Version</Caption1><Body1Stronger>{version ? version : "Loading..."}</Body1Stronger>
                            <Caption1>Build Date</Caption1><Body1Stronger>{buildTime ? new Date(buildTime).toLocaleString() : "Loading..."}</Body1Stronger>
                        </div>
                    </div>
                    {isAdmin && seeDebugInfo &&
                        <>
                            <Switch
                                label="Admin"
                                checked={viewAdminInfo}
                                labelPosition="after"
                                onChange={() => { dispatch(UserLoginActionCreators.requestToogleAdminView()); }}
                            />
                            <Switch
                                label="Debug"
                                checked={viewDebugInfo}
                                labelPosition="after"
                                onChange={() => { dispatch(UserLoginActionCreators.requestToogleDebugView()); }}
                            />
                        </>
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => { closeDialog(); }}
                    >
                        {t("Close")}
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>;
};